/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { InputSignInUserDto } from '../../models/input-sign-in-user-dto';
import { OutputSignInUserDto } from '../../models/output-sign-in-user-dto';

export interface UserManagementSignInPost$Params {
      body?: InputSignInUserDto
}

export function userManagementSignInPost(http: HttpClient, rootUrl: string, params?: UserManagementSignInPost$Params, context?: HttpContext): Observable<StrictHttpResponse<OutputSignInUserDto>> {
  const rb = new RequestBuilder(rootUrl, userManagementSignInPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<OutputSignInUserDto>;
    })
  );
}

userManagementSignInPost.PATH = '/UserManagement/SignIn';
